import React, { useContext, useEffect } from 'react';
import Entity from './Entity';
import { useHistory } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import { UserContext } from '../context/UserContext';

const EntitySelector = (props) => {
	const { setIsFIP, isFip } = useContext(UserContext);
	const EntityType = ['ACCOUNTS', 'APPS'];
	const history = useHistory();
	const isMobile = useIsMobile();
	const handleEntityClick = (type) => {
		if (type === 'ACCOUNTS') {
			setIsFIP(true);
		}
		history.push('/revoke-consent');
	};

	useEffect(() => {
		if (global.ecid || isFip) {
			history.push(`/revoke-consent`);
		}
		else if (props?.location?.state?.consentIdList?.length > 0) {
			history.push(`/revoke-consent`);
		}
		else{
			setIsFIP(false);
		}
	}, []);

	return (
		<div
			style={{
				width: isMobile ? '95%' : '40%',
				margin: '0 auto',
				marginTop: isMobile? '5rem' : '10rem',
				marginBottom: '5rem',
			}}
		>
			<div >
				<p
					style={{
						textAlign: 'left',
						fontSize: props?.customDetails?.fontSize,
						color: props?.customDetails?.textColor,
						wordSpacing: '0.1rem',
					}}
				>
					PLEASE CHOOSE WHICH CONSENTS YOU WOULD LIKE TO VIEW AND MANAGE
				</p>
			</div>
			<div >
				{EntityType.map((type, index) => {
					return (
						<Entity
							entityKey={type.toLowerCase()}
							key={index}
							onClick={() => handleEntityClick(type)}
							customDetails={props.customDetails}
							type={type}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default EntitySelector;
